<template>
    <div
        class="spinner-text"
        :v-bind="$attrs"
    >
        <spinner />
        <span id="loader-text"><slot /></span>
    </div>
</template>

<script>
import spinner from './Spinner';
export default {
    components: {
        spinner,
    },
    name: 'spinner-text',
};
</script>
